(function() {
    'use strict';

    angular.module('competence.constants', [])
        .constant('competenceMessagesConst', {
            delete: 'Kompetencja została usunięta!',
            add: 'Kompetencja została dodana!',
            update: 'Dane Kompetencji zostały zaktualizowane!',
            error: 'Wystąpił błąd podczas dodawania Kompetencji!',
        })
        .constant('competencePermissionsConst', {
            view: {
                value: 'view_competence',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu kompetencji!'
            },
            add: {
                value: 'add_competence',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania kompetencji!'
            },
            update: {
                value: 'change_competence',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji kompetencji!'
            },
            delete: {
                value: 'delete_competence',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania kompetencji!'
            }
        });
})();
